//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "DetailTopPart",
  data() {
    return {
      detail: {},
      info: [],
    };
  },
  props: {
    orderId: {
      type: String,
    },
  },
  mounted() {
    this.getOrderDetail();
  },
  methods: {
    /**
     * @descripttion: 获取订单详情
     * @Author: juanjuanhui
     * @Date: 2021-11-25 10:45:30
     * @param {*}
     */
    getOrderDetail() {
      this.$http.village.getOrderDetail({ id: this.orderId }).then((res) => {
        this.detail = res.data;
        this.info = [res.data];
      });
    },
  },
};
